var render = function render(){var _vm=this,_c=_vm._self._c;return _c('money',_vm._b({on:{"input":function($event){return _vm.$emit('input', arguments[0])}}},'money',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }